<div class="card" *ngIf="newsItem"
     [ngStyle]="{'background-image': 'url('+ background + ')'}"
>
  <a href="{{newsItem.link}}" target="_blank">
    <div class="card-header">
      Sporty's Student Pilot News
    </div>
    <div class="card-footer">
      <div>
        {{newsItem.title}}
      </div>
    </div>
  </a>
</div>
